/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MessageActionDTO { 
    uri: string;
    verb: MessageActionDTO.VerbEnum;
    body?: object;
}
export namespace MessageActionDTO {
    export const VerbEnum = {
        GET: 'GET',
        POST: 'POST',
        PUT: 'PUT',
        DELETE: 'DELETE'
    } as const;
    export type VerbEnum = typeof VerbEnum[keyof typeof VerbEnum];
}


